import "./card-slide.scss";

(function () {
    if (document.querySelectorAll(".js-card-slide").length > 0) {

        const cardSlide = {
            props: {
                displayedItems: null
            },
            init: () => {
                const sliders = document.querySelectorAll(".js-card-slide");
                const windowSize = window.document.body.clientWidth;

                if (windowSize < 580) {
                    cardSlide.props.displayedItems = 1;
                }

                if (windowSize > 579 && window.innerWidth < 1048) {
                    cardSlide.props.displayedItems = 2;
                }

                if (windowSize > 1047) {
                    cardSlide.props.displayedItems = 3;   
                }

                sliders.forEach((slider) => {
                    if (slider.parentElement.parentElement.classList.contains("first__related__content")) {
                        return;
                    }
                    const buttonSlidePrev = slider.querySelector(".card__prev");
                    const buttonSlideNext = slider.querySelector(".card__next");
                    const slidesAmount = parseInt(slider.dataset.slides);

                    if (document.querySelectorAll(".js-customer-size-template").length > 0 && windowSize > 1047) {
                        if (slider.parentElement.classList.contains("js-bundling-block")) {
                            cardSlide.props.displayedItems = 2;
                        } else {
                            cardSlide.props.displayedItems = 3;
                        }
                    }

                    if (slider.parentElement.classList.contains("js-person-listing-block")) {   
                        if (windowSize > 1047) {
                            cardSlide.props.displayedItems = 6;
                        } else { 
                            cardSlide.props.displayedItems = 2;   
                        }
                    }

                    const pages = slidesAmount - cardSlide.props.displayedItems;

                    if (window.innerWidth > 1047) {
                        if (slidesAmount === 2 && !slider.classList.contains("related-content")) {
                            const slide = slider.querySelectorAll(".slide");

                            slide.forEach((s) => {
                                s.style.width = "50%";
                            });
                        }
                    }

                    if (pages > 0) {
                        
                        if (buttonSlideNext !== null) {
                            buttonSlideNext.addEventListener("click", () => {
                                cardSlide.changeSlide("left", slider, pages);
                            });
                        }

                        if (buttonSlidePrev !== null) {
                            buttonSlidePrev.addEventListener("click", () => {
                                cardSlide.changeSlide("right", slider, pages);
                            });
                        }
                    }
                    else {
                        if (buttonSlidePrev !== null) {
                            buttonSlidePrev.setAttribute("disabled", true);
                        }
                        if (buttonSlideNext !== null) {
                            buttonSlideNext.setAttribute("disabled", true);
                        }
                    }

                    cardSlide.detectSwipe(slider, pages);
                });
            },
            detectSwipe: (el, p) => {
                const detect = {
                    startX: 0,
                    endX: 0,
                    minX: 50,
                    maxX: 50
                };
                let direction = null;

                el.addEventListener('touchstart', (event) => {
                    const touch = event.touches[0];
                    detect.startX = touch.screenX;
                });

                el.addEventListener('touchmove', (event) => {
                    const touch = event.touches[0];
                    detect.endX = touch.screenX;
                });

                el.addEventListener('touchend', () => {
                    if (detect.endX === 0) return;

                    if ((Math.abs(detect.endX - detect.startX) > detect.minX)) {
                        direction = (detect.endX > detect.startX) ? 'right' : 'left';

                        cardSlide.changeSlide(direction, el, p);
                    }

                    detect.endX = 0;
                });
            },
            changeSlide: (dir, element, pagesAmount, dataItem) => {
                let sliderIndex = parseInt(getComputedStyle(element).getPropertyValue("--slider__index"));
                let sliderOffset = parseInt(getComputedStyle(element).getPropertyValue("--slider__offset"));
                const slide = element.querySelector(".slide").getBoundingClientRect();
                const sliderTrack = element.querySelector(".slider__track");
                const sliderButtonPrev = element.querySelector(".card__prev");
                const sliderButtonNext = element.querySelector(".card__next");

                if (dir === "left") {
                    if (sliderIndex < pagesAmount) {
                        sliderIndex = sliderIndex + 1;
                        sliderOffset = sliderOffset - slide.width;

                        sliderTrack.style.left = sliderOffset + "px";
                    }
                }

                if (dir === "right") {
                    if (sliderIndex > 0) {
                        sliderIndex = sliderIndex - 1;
                        sliderOffset = sliderOffset + slide.width;
                      
                        if (element.classList.contains("related-content") && sliderIndex == 0) {
                            sliderTrack.style.left = sliderOffset + 10 + "px";
                        }
                        else {
                            sliderTrack.style.left = sliderOffset + "px";
                        }
                    }
                }

                if (dir === "indicator") {
                    sliderIndex = +dataItem;
                    sliderOffset = -12 - slide.width * +dataItem;
                    sliderTrack.style.left = sliderOffset + "px";
                }

                element.style.setProperty("--slider__index", sliderIndex);
                element.style.setProperty("--slider__offset", sliderOffset);

                if (sliderIndex === 0) {
                    sliderButtonPrev.setAttribute("disabled", true);
                    sliderButtonNext.removeAttribute("disabled");
                    element.style.setProperty("--slider__offset", -12);
                }
                else if (sliderIndex === pagesAmount) {
                    sliderButtonNext.setAttribute("disabled", true);
                    sliderButtonPrev.removeAttribute("disabled");
                }
                else {
                    sliderButtonPrev.removeAttribute("disabled");
                    sliderButtonNext.removeAttribute("disabled");
                }
            }
        };

        cardSlide.init();
    }
})();
